<template>
  <div>
    <!-- appbar -->
    <v-app-bar color="white" height="98px" fixed app :style="nav">
      <div class="d-flex flex-column justify-space-around" style="height: 100%">
        <div
          class="d-flex align-center justify-space-between mt-2"
          style="width: 100vw"
        >
          <v-btn icon>
            <v-icon color="accent" @click="drawer = !drawer">mdi-menu</v-icon>
          </v-btn>

          <span>
            <img
              src="@/assets/logo.png"
              alt=""
              style="width: 150px; height: 30px"
            />
          </span>

          <v-btn icon @click="$router.push('/settings')">
            <v-icon color="accent">mdi-cog-outline</v-icon>
          </v-btn>
        </div>
        <div class="primary pa-3 d-flex align-center justify-center">
          <v-text-field
            v-model="text"
            dense
            rounded
            hide-details
            solo
            label="Search"
            @keyup.enter="onSearch"
            dark
            style="width: 320px; flex-grow: 0; flex-shrink: 1"
          >
            <template slot="append">
              <v-img @click="onSearch" src="@/assets/icons/search.svg"> </v-img>
            </template>
          </v-text-field>
        </div>
      </div>
    </v-app-bar>

    <!-- navigation drawer -->
    <v-navigation-drawer
      v-model="drawer"
      :temporary="true"
      app
      color="primary"
      hide-overlay
      width="75%"
    >
      <div :style="drawerLogo"></div>
      <div
        class="d-flex align-center nav-header white mb-4 elevation-1"
        style="height: 52px"
      >
        <v-btn icon color="accent" @click="drawer = !drawer" class="ml-1">
          <v-icon size="17">mdi-arrow-left</v-icon>
        </v-btn>
        <span class="ml-auto mr-4">
          <img
            src="@/assets/logo.png"
            alt=""
            style="width: 150px; height: 30px"
          />
        </span>
      </div>

      <div class="d-flex align-start mt-5">
        <div class="d-flex flex-column align-start">
          <v-btn
            class="mb-5 d-flex align-center justify-start active white--text"
            v-for="(item, i) in menu"
            :key="i"
            :to="item.type == 'route' ? item.path : null"
            color="white"
            :ripple="false"
            plain
            :disabled="!status.connected"
            @click.native="item.type == 'link' ? openBrowser() : closeDrawer()"
          >
            <v-icon
              size="25"
              class="primary lighten-2 rounded-circle mr-2 pa-1"
              >{{ item.icon }}</v-icon
            >

            <span class="white--text body-1">{{ item.label }}</span>
          </v-btn>

          <!-- <v-btn
            v-if="!status.connected"
            class="mb-5 d-flex align-center justify-start active white--text"
            :to="'/saved-routes'"
            color="white"
            :ripple="false"
            plain
          >
            <v-icon size="25" class="accent rounded-circle mr-2 pa-1"
              >mdi-download</v-icon
            >

            <span class="white--text body-1 font-weight">Saved Routes</span>
          </v-btn> -->
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog
      v-if="searchDialog.open"
      fullscreen
      v-model="searchDialog.open"
      style="z-index: 1000"
    >
      <SearchDialog
        v-if="searchDialog.open"
        :name="searchDialog.name"
        @close="closeSearchDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import SearchDialog from "../components/SearchDialog.vue";
import { Network } from "@capacitor/network";
import { mapState } from "vuex";
import { Browser } from "@capacitor/browser";

export default {
  components: {
    SearchDialog,
  },

  async created() {
    try {
      this.status = await Network.getStatus();
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      text: null,
      drawer: false,
      location: null,
      mini: false,
      status: false,
      searchDialog: {
        open: false,
        name: null,
      },

      filters: [
        {
          label: "Περιοχή",
          value: null,
        },
        {
          label: "Τοποθεσίες ενδιαφέροντος",
          value: null,
        },
        {
          label: "Διαδρομή",
          value: null,
        },
      ],
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
      mobileLang: (state) => state.base.mobileLang,
    }),
    nav() {
      return {
        padding: `${this.insets?.top}px 0px 0px 0px`,
        height: `calc(70px+${this.insets?.top}px)`,
      };
    },

    drawerLogo() {
      return {
        background: "#C8D0C9",
        padding: `${this.insets?.top}px 0px 0px 0px`,
        height: `calc(70px+${this.insets?.top}px)`,
        display: "grid",
        "place-items": "center",
      };
    },

    menu() {
      return [
        {
          label: this.$t("menu.islands"),
          icon: "mdi-island",
          path: "/islands",
          type: "route",
        },

        {
          label: this.$t("menu.parking"),
          icon: "mdi-parking",
          path: "/parking",
          type: "route",
        },

        {
          label: this.$t("menu.events"),
          icon: "mdi-calendar-multiple",
          path: "/events",
          type: "link",
        },

        {
          label: this.$t("menu.visited_places"),
          icon: "mdi-map-marker-check",
          path: "/visited_places",
          type: "route",
        },

        {
          label: this.$t("menu.info_settings"),
          icon: "mdi-cog",
          path: "/settings",
          type: "route",
        },
      ];
    },
  },

  methods: {
    onSearch() {
      this.openSearchDialog(this.text);
    },

    openSearchDialog(name) {
      //just for the transition when modal is closed
      this.searchDialog.open = true;
      this.searchDialog.name = name;
    },

    closeSearchDialog() {
      this.searchDialog.open = false;
      this.searchDialog.name = null;
      this.text = null;
    },

    closeDrawer() {
      this.drawer = false;
    },

    async openBrowser() {
      // Check if current language is Greek, if so use the base URL, otherwise use English URL
      const baseUrl = "https://villages.e-naxios.com/";
      const url =
        this.mobileLang?.code === "el"
          ? `${baseUrl}?type=2`
          : `${baseUrl}en?type=2`;

      await Browser.open({ url });
      this.drawer = false;
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn--active > .v-btn__content .v-icon {
  color: var(--v-secondary-base) !important;
  background-color: white !important;
}

.navigation-drawer-title {
  position: relative !important;
}

.v-btn {
  text-transform: none !important;
}
</style>
